import React, { Component } from "react";
import Modal from "react-modal";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy, faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";
import globals from "../../globals";

import {
  faFacebookF,
  faTwitter,
  faLinkedin,
  faWhatsapp
} from "@fortawesome/free-brands-svg-icons";
import {
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton,
  WhatsappShareButton
} from "react-share";
import CopyToClipboard from "react-copy-to-clipboard";
import { isMobile } from "react-device-detect";

import ArrowRight from "../../design/img/arrow_right.png";
class ShareButton extends Component {
  state = { showShareView: false, show: false };

  constructor(props) {
    super(props);
    this.state = {
      url: globals.websiteURL + props.url
    };
  }

  componentWillMount() {
    Modal.setAppElement("body");
  }

  render() {
    return (
      <div className="share-button ">
        <div className="comment_number_icon" onClick={this.handlerShowView}>
          <img
            src={ArrowRight}
            alt="Share"
            width="30px"
            style={{ top: "6px", position: "absolute", left: "0px" }}
          />
        </div>
        {this.renderShareView()}
      </div>
    );
  }

  renderShareView() {
    var style = { top: "-240px" };
    if (this.state.show === true) {
      style = { top: "0px" };
    }
    return (
      <Modal className="follow-views" isOpen={this.state.showShareView}>
        <div className="follow-return" onClick={this.handleCloseView} />
        <div style={style} className="follow-view center">
          <div className="max_width_500 pb-2 pt-2 ">
            <label className="name">Share Url:</label>
            <input
              type="text"
              readOnly={true}
              className="yaystack_input_text mb-3"
              value={this.state.url}
            />
          </div>

          <CopyToClipboard text={this.state.url} onCopy={this.handleCloseView}>
            <button className="btn btn_primary btn_yaystack btn_invite">
              <FontAwesomeIcon icon={faCopy} />
            </button>
          </CopyToClipboard>
          {this.renderMobileShare()}
          <button
            className="btn btn_primary btn_yaystack btn_invite"
            onClick={this.openMailer}
          >
            <FontAwesomeIcon icon={faEnvelope} />
          </button>

          <br />
          <FacebookShareButton
            className="btn btn_primary btn_yaystack btn_invite"
            url={this.state.url}
            beforeOnClick={this.handleCloseView}
          >
            <FontAwesomeIcon icon={faFacebookF} />
          </FacebookShareButton>
          <TwitterShareButton
            className="btn btn_primary btn_yaystack btn_invite"
            url={this.state.url}
            beforeOnClick={this.handleCloseView}
          >
            <FontAwesomeIcon icon={faTwitter} />
          </TwitterShareButton>
          <LinkedinShareButton
            className="btn btn_primary btn_yaystack btn_invite"
            url={this.state.url}
            beforeOnClick={this.handleCloseView}
          >
            <FontAwesomeIcon icon={faLinkedin} />
          </LinkedinShareButton>
          <WhatsappShareButton
            className="btn btn_primary btn_yaystack btn_invite"
            url={this.state.url}
            beforeOnClick={this.handleCloseView}
          >
            <FontAwesomeIcon icon={faWhatsapp} />
          </WhatsappShareButton>
          <br />
          <br />
        </div>
      </Modal>
    );
  }

  handlerShowView = e => {
    const showShareView = !this.state.showShareView;
    this.setState({ showShareView });
    const self = this;
    setTimeout(function() {
      self.setState({ show: true });
    }, 100);
  };

  handleCloseView = e => {
    const self = this;
    this.setState({ show: false });
    setTimeout(function() {
      const showShareView = !self.state.showShareView;
      self.setState({ showShareView });
    }, 500);
  };

  renderMobileShare() {
    if (isMobile) {
      return (
        <button
          className="btn btn_primary btn_yaystack btn_invite"
          onClick={this.openMessage}
        >
          <FontAwesomeIcon icon={faPhone} />
        </button>
      );
    }
    return <React.Fragment />;
  }

  openMailer = event => {
    this.handleCloseView();
    const subject = "";

    const body = this.state.url;
    window.location.href = `mailto:?subject=${subject}&body=${body}`;
  };
  openMessage = event => {
    this.handleCloseView();
    const body = this.state.url;

    window.location.href = `sms:?&body=${body}`;
  };
}

export default ShareButton;



// WEBPACK FOOTER //
// ./src/components/share/share_button.jsx